import React, { Component } from 'react';
import { Picky } from 'react-picky';
import {
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  InputLabel,
  Button,
} from '@mui/material';
import * as _ from 'lodash';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  filterQuery,
  getLocalStorageTabs,
  processTabsWithUserDesignation,
  dateOptions,
  getFilterTabs,
  getTabsWithDesignationDetails,
} from './helper';
import 'react-picky/dist/picky.css';
import './../styles/filter.css';
import { isNull, dateFilterFormater } from 'utils/helper';

import { falseDependencies } from 'mathjs';

const defaultFilter = [
  {
    type: 'date',
    name: '_mo_created_at',
    label: 'Created Date',
    value: null,
    options: dateOptions,
  },
  {
    type: 'date',
    name: '_mo_updated_at',
    label: 'Updated Date',
    value: null,
    options: dateOptions,
  },
];

class FilterData extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      tabs: [],
      index: 0,
      customDate: false,
      passStructuredFilter: falseDependencies,
    };
  }

  componentDidMount() {
    this.initTabs();
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.teamdesignations !== this.props.teamdesignations) {
      this.processRefFieldsWithHelpers(this.state.tabs || []);
    }
    if (
      prevProps.selectedView &&
      prevProps.selectedView.name !== this.props.selectedView.name
    ) {
      this.initTabs();
    }
  }

  componentWillUnmount() {
    this.resetFilterCondition();
  }

  initTabs = () => {
    const fields =
      this.props.template &&
      this.props.template.template &&
      JSON.parse(this.props.template.template).fields;
    let tabs: any = [];
    if (fields.length > 0) {
      tabs = getLocalStorageTabs(
        fields,
        this.props.templateId,
        this.getViewName(),
        this.props.teamdesignations
      );
      if (tabs.length > 0) {
        this.setTabs(fields, tabs);
      } else {
        const filtersToUse = this.props.initialDefaultFilters || defaultFilter;
        this.setTabs(fields, [...filtersToUse]);
      }
    }
  };

  getViewName = () => {
    const { selectedView } = this.props;
    if (
      selectedView &&
      selectedView['name'] &&
      selectedView['name'].trim() !== ''
    ) {
      return selectedView['name'];
    }
    return '';
  };

  processRefFieldsWithHelpers = (tabs: any) => {
    const { teamdesignations, userTeamDetails, selectedView } = this.props;
    const filteredTabs = getTabsWithDesignationDetails(
      tabs,
      userTeamDetails,
      teamdesignations,
      selectedView
    );
    const count = filteredTabs.filter(
      (item: any) => item && item.value && item.value.length !== 0
    );
    if (this.props.setFilterCount) {
      this.props.setFilterCount(count.length);
    }
    this.setState({ tabs: filteredTabs });
  };

  setTabs = (fields: any, existTabs: any) => {
    const tabs: any = getFilterTabs(
      fields,
      existTabs,
      this.props.teamdesignations
    );

    this.setState({ tabs }, () => {
      this.processRefFieldsWithHelpers(tabs);
    });
  };

  closeCustomDate = () => {
    this.setState({ customDate: false });
  };

  handleChange = (name: string) => (date: moment.Moment | null) => {
    const stateCopy: any = Object.assign({}, this.state);
    stateCopy.tabs[stateCopy.index][name] =
      date && moment.isMoment(date) ? date.toISOString() : null;
    this.setState(stateCopy);
  };

  dailogCustomDate = () => {
    const { tabs, index, customDate } = this.state;

    return (
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={customDate}
          className="custom-date-dialog"
        >
          <DialogTitle className="title">Custom Date</DialogTitle>

          <DialogContent>
            <div className="custom-date-wrapper">
              <div className="custom-date-select">
                <InputLabel shrink className="custom-date-select-lable">
                  From
                </InputLabel>

                <DatePicker
                  format="DD MMM YYYY"
                  value={
                    tabs[index]?.from ? moment(tabs[index].from) : moment()
                  }
                  onChange={this.handleChange('from')}
                  className="date-select"
                />
              </div>

              <div className="custom-date-select">
                <InputLabel shrink={true} className="custom-date-select-lable">
                  To
                </InputLabel>

                <DatePicker
                  format="DD MMM YYYY"
                  value={tabs[index]?.to ? moment(tabs[index].to) : moment()}
                  onChange={this.handleChange('to')}
                  className="date-select"
                />
              </div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button
              className="custom-date-select-cancel"
              onClick={this.closeCustomDate}
              variant="outlined"
            >
              Cancel
            </Button>

            <Button
              className="custom-date-select-done"
              onClick={this.closeCustomDate}
            >
              Done
            </Button>
          </DialogActions>
        </Dialog>
      </LocalizationProvider>
    );
  };

  selectDateOption = (name: any) => (value: any) => {
    const stateCopy: any = Object.assign({}, this.state);
    const index = this.state.tabs.findIndex((item: any) => item.name === name);
    const targetTabIndex = stateCopy.tabs.findIndex(
      (item: any) => item.name === name
    );
    if (
      targetTabIndex === -1 ||
      stateCopy.tabs[targetTabIndex].type !== 'date'
    ) {
      return;
    }

    let newTargetTabValue = value;
    if (value === 'None') {
      newTargetTabValue = null;
    } else if (value === 'Custom') {
      stateCopy.customDate = true;
      stateCopy.index = targetTabIndex;
    }
    stateCopy.tabs[targetTabIndex].value = newTargetTabValue;

    if (
      this.props.isDashboardContext &&
      stateCopy.tabs &&
      stateCopy.tabs.length > 0
    ) {
      stateCopy.tabs.forEach((tab: any, idx: number) => {
        if (tab.type === 'date' && idx !== targetTabIndex) {
          stateCopy.tabs[idx].value = null;
        }
      });
    }
    if (value === 'Custom') {
      stateCopy.customDate = true;
      stateCopy.index = index;
      stateCopy.tabs[index].value = value;
    } else {
      if (value === 'None') {
        stateCopy.tabs[index].value = null;
      } else {
        stateCopy.tabs[index].value = value;
      }
    }
    this.setState(stateCopy);
  };

  selectStatusOption = (name: any) => (value: any) => {
    const stateCopy: any = Object.assign({}, this.state);
    const index = this.state.tabs.findIndex((item: any) => item.name === name);
    stateCopy.tabs[index].value = value;
    this.setState(stateCopy);
  };

  getQuery = () => {
    let queryString = '';
    let filterArray: any = [];
    const filterObj = localStorage.getItem('filterObj') || '';
    if (filterObj.trim()) {
      filterArray =
        JSON.parse(filterObj).length > 0 ? JSON.parse(filterObj) : [];

      const teamExistsIndex = _.findIndex(filterArray, {
        templateId: this.props.templateId,
        name: this.getViewName(),
      });
      if (teamExistsIndex >= 0) {
        filterArray[teamExistsIndex].filterFields = this.state.tabs;
      } else {
        filterArray.push({
          templateId: this.props.templateId,
          filterFields: this.state.tabs,
          name: this.getViewName(),
        });
      }
    } else {
      filterArray = [
        {
          templateId: this.props.templateId,
          filterFields: this.state.tabs,
          name: this.getViewName(),
        },
      ];
    }

    const count = this.state.tabs.filter(
      (item: any) => item && item.value && item.value.length !== 0
    );

    if (filterArray.length > 0) {
      const filterStringfy = JSON.stringify(filterArray);
      localStorage.setItem('filterObj', filterStringfy);
    }

    queryString = filterQuery(this.state.tabs);
    if (!this.props.passStructuredFilter) {
      this.props.applyFilter({
        type: 'apply',
        queryString,
        count: count.length,
        isDashboardContext: this.props.isDashboardContext,
      });
      return;
    }

    const collectedFilters: { [key: string]: any } = {};
    let activeFilterCount = 0;

    this.state.tabs.forEach((tab: any) => {
      let selectedValue: any = null;

      if (
        tab.value &&
        tab.value !== 'None' &&
        (Array.isArray(tab.value) ? tab.value.length !== 0 : true)
      ) {
        if (tab.type === 'date') {
          if (tab.value === 'Custom') {
            selectedValue = [
              {
                from: moment(tab.from).toISOString(),
                to: moment(tab.to).toISOString(),
              },
            ];
          } else {
            const { from, to } = dateFilterFormater(tab.value);
            selectedValue = [{ from, to }];
          }
        } else {
          selectedValue = Array.isArray(tab.value) ? tab.value : [tab.value];
        }
        activeFilterCount++;
      }
      collectedFilters[tab.name] = selectedValue;
    });

    this.props.applyFilter({
      type: 'apply_structured',
      filters: collectedFilters,
      count: activeFilterCount,
      isDashboardContext: this.props.isDashboardContext,
    });
  };

  resetFilterCondition = () => {
    const { teamdesignations, userTeamDetails, selectedView } = this.props;
    const defaultQuery =
      selectedView && selectedView['fq'] ? selectedView['fq'] : '';

    let stateCopy: any = Object.assign({}, this.state);
    const tabsCopy = [...this.state.tabs];

    tabsCopy.forEach((item: any) => {
      if (
        item.type === 'picker' ||
        item.type === 'status_picker' ||
        item.type === 'cascading-dropdown'
      ) {
        item.value = [];
      } else {
        item.value = null;
      }
    });

    const updatedTabs = processTabsWithUserDesignation(
      tabsCopy,
      userTeamDetails,
      teamdesignations,
      defaultQuery
    );

    stateCopy.tabs = updatedTabs;
    this.setState(stateCopy);
    return updatedTabs;
  };

  clearFilter = () => {
    const updatedTabs = this.resetFilterCondition();
    let filterArray: any = [];
    const filterObj = localStorage.getItem('filterObj') || '';
    if (filterObj.trim()) {
      filterArray =
        JSON.parse(filterObj).length > 0 ? JSON.parse(filterObj) : [];
      const deletedElements = _.remove(
        filterArray,
        (item: any) =>
          item.templateId === this.props.templateId &&
          item.name === this.getViewName()
      );
      if (deletedElements.length > 0) {
        const filterStringfy = JSON.stringify(filterArray);
        filterArray.length === 0
          ? localStorage.removeItem('filterObj')
          : localStorage.setItem('filterObj', filterStringfy);
      }
    }
    const count =
      updatedTabs &&
      updatedTabs.filter(
        (item: any) => item && item.value && item.value.length !== 0
      );
    this.props.applyFilter({
      type: 'clear',
      count: !isNull(count) ? count.length : 0,
    });
  };

  render() {
    return (
      <div className="filter-data-container">
        <div className="filter-data-tab-wrapper">
          {this.state.tabs &&
            this.state.tabs.map((item: any, index: number) => {
              if (
                item.type === 'picker' ||
                item.type === 'status_picker' ||
                item.type === 'cascading-dropdown'
              ) {
                return (
                  <div key={index} className="filter-data-select">
                    <p>{item.label}</p>
                    <Picky
                      options={item.options}
                      value={this.state.tabs[index].value}
                      multiple={true}
                      numberDisplayed={0}
                      includeSelectAll={true}
                      includeFilter={true}
                      onChange={this.selectStatusOption(item.name)}
                      dropdownHeight={250}
                    />
                  </div>
                );
              } else {
                return (
                  <div key={index} className="filter-data-select">
                    <p>{item.label}</p>
                    <Picky
                      options={item.options}
                      value={this.state.tabs[index].value}
                      multiple={false}
                      includeFilter={true}
                      onChange={this.selectDateOption(item.name)}
                      dropdownHeight={250}
                    />
                  </div>
                );
              }
            })}
        </div>
        <div className="filter-data-buttons-wrapper">
          <Button
            className="filter-data-clear-button"
            onClick={this.clearFilter}
            variant="outlined"
          >
            Clear
          </Button>
          <Button className="filter-data-apply-button" onClick={this.getQuery}>
            Apply
          </Button>
        </div>
        {this.dailogCustomDate()}
      </div>
    );
  }
}

export default FilterData;
